import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { BsDot } from 'react-icons/bs';
import { HiBars2 } from 'react-icons/hi2';
import CopyLinkButton from '../shared/shareLinks';
import './product.css';

function ProductItem({ item, category, deleteProduct, onOpenDetail, currencySymbol = '' }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({
    id: item.id,
    data: {
      type: 'item',
      category: category,
      item: item
    }
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  // Get the first letter of the product name for the placeholder
  const getInitial = () => {
    return item.productName?.charAt(0).toUpperCase() || 'P';
  };

  // Always return blue color for product thumbnails
  const getColorClass = () => {
    return 'b'; // Blue color (#007EA0)
  };

  return (
    <div
      className="service-item"
      ref={setNodeRef}
      style={style}
      data-dragging={isDragging}
      onClick={() => {
        if (onOpenDetail) {
          onOpenDetail(item);
        }
      }}
    >
      <HiBars2
        className="menu-icon service-menu-icon drag-handle"
        {...attributes}
        {...listeners}
      />
      
      {/* Product Image or Initial Square */}
      {item.images && item.images.length > 0 ? (
        <div className="product-image">
          {console.log("Product image:", item.images[0])}
          <img
            src={item.images[0].url}
            alt={item.productName}
            onError={(e) => {
              console.error("Image failed to load:", item.images[0].url);
              e.target.style.display = 'none';
              e.target.parentNode.innerHTML = `
                <div class="${`product-initial-square ${getColorClass()}`}">
                  ${getInitial()}
                </div>
              `;
            }}
          />
        </div>
      ) : (
        <div className={`product-initial-square ${getColorClass()}`}>
          {getInitial()}
        </div>
      )}
      
      <div className="_text">
        <div className="product-header">
          <h3>{item.productName}</h3>
          {item.brand && (
            <div className="product-brand-name">
              {item.brand.brandName}
            </div>
          )}
        </div>
        
        {(item.barcode || item.sku) && (
          <p className="product-details">
            {item.barcode && <span>Barcode: {item.barcode}</span>}
            {item.barcode && item.sku && <span className="__doty"><BsDot /></span>}
            {item.sku && <span>SKU: {item.sku}</span>}
          </p>
        )}
      </div>
      
      <div className="product-price">
        <div className="product-price__top">
          {/* Only sell-online products have a public shop page to link to */}
          {item.sellOnline === 1 && (
            <CopyLinkButton type="product" id={item.id} className="share-link-btn--reveal share-link-btn--sm" title="Copy product link" />
          )}
          <div className="retail-price">{currencySymbol}{item.retailPrice?.toFixed(2)}</div>
        </div>
        <div className="stock-price">{currencySymbol}{item.stockPrice?.toFixed(2)}</div>
        {item.trackStock === 1 && (
          <div className="product-stock">
            Stock: {Math.max(0, parseInt(item.quantity, 10) || 0)}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductItem;